import { ref } from "vue";
import store from "@/store";
import router from "@/router";
import { adminAPI } from "@/laravel/config";

const getItemsOfItemsOfItems = async (table, id1, id2) => {
  const res = ref(null);
  const err = ref(null);

  // start
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };

    // Add Authorization header only if token exists
    if (store.state?.user?.token) {
      requestOptions.headers.Authorization = `Bearer ${store.state.user.token}`;
    }

    const response = await fetch(
      adminAPI + `/${table}` + `/${id1}` + `/${id2}`,
      requestOptions,
    );

    if (response.status === 401) {
      router.replace("/login");
      throw new Error("Unauthorized");
    }

    if (response.status === 403) {
      throw new Error("Forbidden");
    }

    if (response.status >= 500) {
      throw new Error("Server error");
    }

    if (!response.ok) {
      throw new Error(
        `Network response was not OK: ${response.status} ${response.statusText}`,
      );
    }

    const data = await response.json();
    res.value = data;
    
  } catch (error) {
    err.value = error;
  }

  return { res, err };
};

export default getItemsOfItemsOfItems;
